module.exports = __webpack_public_path__ + "static/media/bl.b256e7f3.svg";